import type { ReactElement } from "react"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import _t from "@core/i18n"
import DomainSearchPrompt from "@gatsby-plugin-domain-search/components/DomainSearchPrompt"
import DomainSearchSwitchElement from "@gatsby-plugin-domain-search/components/DomainSearchSwitchElement"
import SearchSectionUdsHeader from "@gatsby-plugin-domain-search/components/SearchSectionUdsHeader"
import useDomainLinksQuery from "@gatsby-plugin-domain-search/hooks/useDomainLinksQuery"
import useDomainSearchPromptInput from "@gatsby-plugin-domain-search/hooks/useDomainSearchPromptInput"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import type { CenteredDomainSearchSectionFlatData } from "@gatsby-plugin-generic-page/fragments/centeredDomainSearchSection"
import { ContainerWidthType } from "@gatsby-plugin-generic-page/fragments/containerSettings"
import { SquidexComponentType } from "@gatsby-plugin-generic-page/types/componentType"
import DomainInputField from "~/components/DomainInputField"
import DomainLinks from "~/components/DomainLinks"
import isEmpty from "~/lib/isEmpty"

function CenteredDomainSearchSection({
  captionIcon,
  caption,
  title,
  text,
  sectionSettings,
}: CenteredDomainSearchSectionFlatData): ReactElement<CenteredDomainSearchSectionFlatData> {
  const isHeaderPropUsed = [captionIcon, caption, title, text].some(
    (prop) => prop !== undefined
  )
  const domainLinks = useDomainLinksQuery()
  const {
    value,
    setValueToRandomPrompt,
    setValue,
    onSubmitButtonClick,
    isPending,
  } = useDomainSearchPromptInput()

  const headerCaption = captionIcon
    ? { __typename: SquidexComponentType.CAPTION_ICON, captionIcon }
    : caption
      ? { __typename: SquidexComponentType.CAPTION, text: caption }
      : undefined

  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer
        {...sectionSettings?.containerSettings}
        containerWidth={
          isEmpty(sectionSettings?.containerSettings?.containerWidth)
            ? undefined
            : ContainerWidthType.MEDIUM
        }
      >
        {isHeaderPropUsed ? (
          <AlignContentOrg horizontalAlign="center" horizontalAlignType="both">
            <SearchSectionUdsHeader
              caption={headerCaption}
              title={title}
              text={text}
            />
          </AlignContentOrg>
        ) : null}

        <DomainSearchSwitchElement
          domainSearchInput={
            <DomainInputField
              placeholderText={_t("domainSearch.menuInputPlaceholder")}
            />
          }
          domainSearchPrompt={
            <DomainSearchPrompt
              value={value}
              isPending={isPending}
              setValue={setValue}
              onSubmitButtonClick={onSubmitButtonClick}
              onRandomizePrompt={setValueToRandomPrompt}
            />
          }
        />

        {!isEmpty(domainLinks) && (
          <PushOrg topSpace={4}>
            <DomainLinks domainLinks={domainLinks} />
          </PushOrg>
        )}
      </BaseContainer>
    </BaseSection>
  )
}

export default CenteredDomainSearchSection
